
import React, { useState, useEffect, useRef } from 'react';
import './Menu.css';
import { Link } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import RecommendationsCarousel from './RecommendationsCarousel';

function Menu() {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [loading]);

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        const docRef = doc(db, 'siteContent', 'menuRecommendations');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setRecommendations(docSnap.data().recommendations || []);
        } else {
          console.log("No se encontraron recomendaciones de menú en Firestore.");
        }
      } catch (error) {
        console.error("Error fetching menu recommendations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, []);

  if (loading) {
    return (
      <section id="menu" className="menu-section">
        <div className="menu-recommendations-wrapper">
          <p>Cargando recomendaciones del menú...</p>
        </div>
      </section>
    );
  }

  const menuSectionStyle = {
    backgroundImage: `url('/fondosedes.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <section id="menu" className="menu-section" ref={sectionRef} style={menuSectionStyle}>
      <div className={`menu-recommendations-wrapper ${isVisible ? 'is-visible' : ''}`}>
        <h2>Nuestras Recomendaciones</h2>
        {recommendations.length > 0 ? (
          <RecommendationsCarousel recommendations={recommendations} />
        ) : (
          <p>No hay recomendaciones de menú configuradas.</p>
        )}
        <Link to="/menu" className="menu-button">Ver Menú Completo</Link>
      </div>
    </section>
  );
}

export default Menu;
